import React from 'react'
import {dpoReport, dpoReportSplits, dpoLatestReport} from "../api/api";
import { Button, notification} from 'antd'

import {DefaultProps, RefTable, Validator} from "./RefTable";

const DownloadReport = (props) => {
    const [month, setMonth] = React.useState()
    React.useEffect(() => {
        const {effective_month} = props.data.filter(x => x.dpo_id === props.dpo_id)[0] || {}
        setMonth(effective_month)
    }, [])
    return <Button disabled={!month} onClick={async () => {
        try {
            await props.onDownload(month);//dpoReport(row.id, effective_month, 'pdf');
        } catch (err) {
            notification.error({message: "Report viewing failed"});
        }
    }}>Download</Button>
}


export const PostalOperator = (props) => <RefTable {...props}/>;

PostalOperator.defaultProps = {
    ...DefaultProps,
    title: "Postal Operators",
    tableSchema: "po",
    tableName: "po",
    edit: true,
    add: true,
    theadHeight: 84,
    validator: {
        dpo_fee: new Validator("dpo_fee", async (value) => {
            if (value < 0)
                return Promise.reject("Duty cannot be negative")
        })
    },
    enrichColumns: async (columns) => {
        const {data: {rows: data = []}} = await dpoLatestReport()
        return [
            {
            name: "id",
            title: "Latest Commission Report PDF",
            width: 120,
            formatter: (row, index) => <DownloadReport key={index} data={data} dpo_id={row.id}
                                                       onDownload={async (m) => dpoReport(row.id, m, 'pdf')}/>
        }, {
            name: "id",
            title: "Latest Commission Report CSV",
            width: 120,
            formatter: (row, index) => <DownloadReport key={index} data={data} dpo_id={row.id}
                                                       onDownload={async (m) => dpoReport(row.id, m, 'csv')}/>
        }, {
            name: "id",
            title: "Latest Handled Order Report",
            width: 120,
            formatter: (row, index) => <DownloadReport key={index} data={data} dpo_id={row.id}
                                                       onDownload={async (m) => dpoReportSplits(row.id, m)}/>
        }, ...columns]
    }
}
